import { ProgressIndicator, Stack } from '@fluentui/react';
import React from 'react';
import { useNotifications } from '../../contexts/notificationContext';

const MainProgressIndicator = () => {

    const { infoMessages } = useNotifications();

    const styles = {
        stack: {
            root: {
                backgroundColor: "rgba(0, 0, 0, 0.75)",
                inset: "0 0 0 0",
                position: "fixed",
                zIndex: 1000001, // L'overlay des Modals de Fluent UI ont un z-index égal à 1000000
            }
        },
        progressIndicator: {
            itemName: { color: "white", textShadow: "0 0 10px black" },
            root: { width: "58%" }
        }
    };

    if (infoMessages.length > 0)
        return <Stack id="mainProgressIndicator" horizontalAlign="center" verticalAlign="center" verticalFill styles={styles.stack}>
            <ProgressIndicator label={infoMessages[0].message} styles={styles.progressIndicator} />
        </Stack>;
    else return null;

};

export default MainProgressIndicator;